module.exports = __webpack_public_path__ + "img/screenshot.dbacc780.png";